export const getMilliseconds = () => new Date().getTime();
